import { render, staticRenderFns } from "./GroupOverview.vue?vue&type=template&id=64d6eefd"
import script from "./GroupOverview.vue?vue&type=script&lang=js"
export * from "./GroupOverview.vue?vue&type=script&lang=js"
import style0 from "./GroupOverview.vue?vue&type=style&index=0&id=64d6eefd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports